import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../lib/api';

const initialState = {
  transferTypes: [],
  selected: null,
  allSupportedCountries: [],
};

export const fetchTransferTypes = createAsyncThunk(
  'transfersTypes/fetchTransferTypes',
  async () => {
    const response = await api.getTransferTypes();

    return response.transferTypes.filter((t) => !t.disabled);
  }
);

const transferTypesSlice = createSlice({
  name: 'transfersTypes',
  initialState,
  reducers: {
    selectTransferType(state, action) {
      state.selected = action.payload;
    },
    resetTransferTypes: (state) => {
      state.selected = 1;
    },
  },
  extraReducers: {
    [fetchTransferTypes.fulfilled]: (state, action) => {
      state.transferTypes = action.payload;
      state.allSupportedCountries = action.payload.reduce((acc, curr) => {
        acc.push(...curr.supportedCountries);
        return acc;
      }, []);
      state.selected = 1;
    },
  },
});

export const { selectTransferType, resetTransferTypes } = transferTypesSlice.actions;

export default transferTypesSlice.reducer;
